import { Controller } from "@hotwired/stimulus"
import '../../_jquery';

export default class extends Controller {
  static targets = ['content', 'accordion']

  connect() {
    this.doSomethingIncomprehensibleWithContent()
    this.observeContent()
  }

  observeContent() {
    let observer = new window.MutationObserver(function (mutations, observer) {
      this.doSomethingIncomprehensibleWithContent()
    }.bind(this));
    observer.observe(this.contentTarget, { subtree: true, attributes: true, childList: true });
  }

  doSomethingIncomprehensibleWithContent() {
    $('h1', this.contentTarget).each(function () {
      let textColor;

      textColor = $('span', this).css('color');

      if (textColor) {
        $(this).css('color', textColor);
      } else {
        $(this).css('color', 'var(--color-primary)');
      }
    });
  }

  toggleAccordion(ev) {
    $(ev.currentTarget).toggleClass('opened');
    $(ev.currentTarget).siblings('.component-text-accordion__content').slideToggle();
  }
}
